/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type ShareboxMatchStatus =
  (typeof ShareboxMatchStatus)[keyof typeof ShareboxMatchStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShareboxMatchStatus = {
  Unmatched: 0,
  Matched: 1,
  Emptied: 2,
} as const;
